import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Container,
  Grid,
  GridItem,
  Image,
  Text,
} from "@chakra-ui/react";
import SubtitleIcon from "common/assets/img/subtitleIcon.png";
import { landingPageConstants } from "common/landingPageConstants";

const faqData = [
  {
    question: "What is Manage360?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    question: "Is my data secure with Manage360?",
    answer:
      "Non ac commodo bibendum et ultrices turpis risus tempus viverra. Sit massa nunc donec eget quisque elit quam faucibus elementum. Amet libero malesuada aenean commodo amet enim.",
  },
  {
    question: "Can I share passwords securely with my team?",
    answer:
      "Mauris eget pulvinar vel aenean pellentesque amet elit. Amet egestas tempus venenatis nam.",
  },
  {
    question: "Does it support automation?",
    answer:
      "Pulvinar pretium morbi orci parturient nulla scelerisque et neque. Ultrices adipiscing sollicitudin ante fermentum ultricies.",
  },
  {
    question: " Can I customize the dashboard and reports?",
    answer:
      "Pulvinar pretium morbi orci parturient nulla scelerisque et neque. Ultrices adipiscing sollicitudin ante fermentum ultricies.",
  },
  {
    question: "Do I need technical skills to use Manage360?",
    answer:
      "Pulvinar pretium morbi orci parturient nulla scelerisque et neque. Ultrices adipiscing sollicitudin ante fermentum ultricies.",
  },
];

const FAQ = () => {
  return (
    <Container maxW="container.xl">
      <Box className="faqSection" id="faq">
        <Box className="faqMainBox">
          <Grid templateColumns={{ md: "repeat(2, 1fr)" }} gap={"60px"}>
            <GridItem colSpan={{base: 2, md: 2, lg: 1}}>
              <Box className="sectionTitlebox leftside" margin={"inherit"} maxW={"496px"} width={"100%"}>
                <Text className="iconSubtitle">
                  {" "}
                  <Image
                    src={SubtitleIcon}
                    height={"16px"}
                    width={"16px"}
                    alt=""
                  />{" "}
                  {landingPageConstants.similarQuestion}
                </Text>
                <Text className="sectionTitle">{landingPageConstants.faqTitle}</Text>
                <Text className="sectionDesc">
                  {landingPageConstants.faqDesc}
                </Text>
              </Box>
            </GridItem>
            <GridItem colSpan={{base: 2, md: 2, lg: 1}}>
              <Accordion allowMultiple allowToggle>
                {faqData.map((item, index) => (
                  <AccordionItem key={index} className="accordianItemBox">
                    {({ isExpanded }) => (
                      <>
                      <div className={`accordianItem ${isExpanded ? "activeAccordian" : ""}`}>
                        <h2>
                          <AccordionButton>
                            <Box as="span" flex="1" textAlign="left">
                              {item.question}
                            </Box>
                            {isExpanded ? (
                              <MinusIcon color="#3c2fc0" fontSize="14px" />
                            ) : (
                              <AddIcon color="#A4ACB9" fontSize="14px" />
                            )}
                          </AccordionButton>
                        </h2>
                        <AccordionPanel className="panelContent" pb={4} pt={0}>
                          {item.answer}
                        </AccordionPanel>
                        </div>
                      </>
                    )}
                  </AccordionItem>
                ))}
              </Accordion>
            </GridItem>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default FAQ;
